import { RESTMethods } from '../../../NonReact/constants/REST'
import { ApplicationDirectory, ApplicationDirectoryFormData } from '../Types/Types'

/**
 * It takes in a form state, a current directory, and a method, and returns a payload
 * @param {ApplicationDirectoryFormData} state - ApplicationDirectoryFormData - this is the state of
 * the form
 * @param {ApplicationDirectory} currentDirectory - ApplicationDirectory - This is the current
 * directory that is being edited.
 * @param {string} method - string - The HTTP method that will be used to make the request.
 * @returns An object with a description and a telephone number.
 */
export const DirectoryRequestMapper = (
    state: ApplicationDirectoryFormData,
    currentDirectory: ApplicationDirectory,
    method: string
): ApplicationDirectory => {
    let payload: ApplicationDirectory = {}

    const { directoryDetails }: ApplicationDirectoryFormData = state

    if (directoryDetails?.telSysID && directoryDetails?.description) {
        payload = {
            Description: directoryDetails.description
        }

        if (method === RESTMethods.PUT && directoryDetails.telNumber !== currentDirectory.TelephoneNumber) {
            payload.TelephoneNumber = directoryDetails.telNumber
        }
    }
    return payload
}
